import {
  Box,
  Card,
  CardActionArea,
  CardContent,
  Chip,
  IconButton,
  Stack,
  Typography,
} from '@mui/material';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import { useTranslation } from 'react-i18next';
import type { TimesheetEntryListItem } from '../types';

export interface LancamentoCardProps {
  entry: TimesheetEntryListItem;
  onEdit: (entry: TimesheetEntryListItem) => void;
  onDelete: (entry: TimesheetEntryListItem) => void;
}

export function LancamentoCard({ entry, onEdit, onDelete }: LancamentoCardProps): JSX.Element {
  const { t } = useTranslation();
  return (
    <Card variant="outlined" sx={{ mb: 1 }}>
      <Stack direction="row" alignItems="stretch">
        <CardActionArea
          onClick={() => onEdit(entry)}
          aria-label={t('features.apontamentos.actions.edit', { id: entry.id })}
          sx={{ flex: 1, minHeight: 56 }}
        >
          <CardContent sx={{ py: 1.25, px: 1.5, '&:last-child': { pb: 1.25 } }}>
            <Stack direction="row" alignItems="center" spacing={1} sx={{ mb: 0.5 }}>
              <Typography
                component="span"
                sx={{ fontFamily: 'monospace', fontWeight: 600, fontSize: 18 }}
              >
                {entry.horas}
              </Typography>
              {entry.tipoHoraSigla && (
                <Chip label={entry.tipoHoraSigla} size="small" variant="outlined" />
              )}
              <Box sx={{ flex: 1 }} />
            </Stack>
            <Typography variant="body2" sx={{ fontWeight: 500 }} noWrap>
              {entry.clienteNome} / {entry.clienteProjetoNome}
            </Typography>
            {entry.atividade && (
              <Typography
                variant="caption"
                color="text.secondary"
                sx={{
                  display: '-webkit-box',
                  WebkitLineClamp: 2,
                  WebkitBoxOrient: 'vertical',
                  overflow: 'hidden',
                }}
              >
                {entry.atividade}
              </Typography>
            )}
          </CardContent>
        </CardActionArea>
        <IconButton
          color="error"
          aria-label={t('features.apontamentos.actions.delete', { id: entry.id })}
          onClick={() => onDelete(entry)}
          sx={{ alignSelf: 'center', minWidth: 44, minHeight: 44, mr: 0.5 }}
        >
          <DeleteOutlineIcon />
        </IconButton>
      </Stack>
    </Card>
  );
}
